import { Event, Identifiable, VideoConferenceCallLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveVideoConferenceCall(httpClient: HttpClient) {
  return ({ uuid, name }: Identifiable<Event>) =>
    httpClient
      .sendHttpRequest<Identifiable<VideoConferenceCallLink>>({
        endpoint: "/zoom/meeting",
        method: HttpMethods.POST,
        data: { name },
      })
      .then((link) => ({
        ...link,
        uri: link.uuid,
      }));
}

export { saveVideoConferenceCall };
